import { type AddressDto, AddressType } from "Infrastructure/Api/Api";
import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

// 5-digit postal code with optional space (e.g. "76302" or "763 02").
// Matches both Czech (PSČ) and Slovak (PSČ / Poštové smerovacie číslo) formats.
export const POSTAL_CODE_REGEX_5_DIGIT = /^\d{3} ?\d{2}$/;

export const getAddressValidationSchema = (t: TFunction) =>
  z.object({
    addressID: z.number().nullish(),
    type: z.enum(AddressType),
    street: z.string().min(1),
    streetNumber: z.string().min(1),
    orientationNumber: z.string().nullish(),
    postalCode: z
      .string()
      .min(1)
      .regex(
        POSTAL_CODE_REGEX_5_DIGIT,
        t(Resources.Validation.InvalidPostalCode),
      ),
    municipality: z.string().min(1),
  });

export type AddressValidationSchema = z.infer<
  ReturnType<typeof getAddressValidationSchema>
>;

export const businessAddressValidationSchema = z.object({
  addressID: z.number().nullish(),
  type: z.enum(AddressType),
  street: z.string().nullish(),
  streetNumber: z.string().nullish(),
  orientationNumber: z.string().nullish(),
  postalCode: z.string().nullish(),
  municipality: z.string().nullish(),
});

export type BusinessAddressValidationSchema = z.infer<
  typeof businessAddressValidationSchema
>;

export const addressDtoToValidationSchema = (
  address?: AddressDto,
): AddressValidationSchema | undefined =>
  address
    ? {
        addressID: address.addressID,
        type: address.type,
        street: address.street ?? "",
        streetNumber: address.streetNumber ?? "",
        orientationNumber: address.orientationNumber,
        postalCode: address.postalCode ?? "",
        municipality: address.municipality ?? "",
      }
    : undefined;
